
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkIssueItemsGrid extends Serenity.EntityGrid<JobWorkIssueItemsRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkIssueItems'; }
        protected getDialogType() { return JobWorkIssueItemsDialog; }
        protected getIdProperty() { return JobWorkIssueItemsRow.idProperty; }
        protected getInsertPermission() { return JobWorkIssueItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkIssueItemsRow.localTextPrefix; }
        protected getService() { return JobWorkIssueItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}